<template>
    <v-menu tile offset-y transition="slide-y-transition">
        <template #activator="scope">
            <app-button icon :disabled="disabled" small v-bind="scope.attrs" v-on="scope.on">
                <v-icon size="1rem">
                    {{ fields[`${active}`] ? getIcon(fields[`${active}`].icon) : getIcon('form') }}
                </v-icon>
            </app-button>
        </template>
        <v-list dense outlined>
            <v-list-item-group :value="active" color="primaryText">
                <v-list-item
                    v-for="(fieldItem, i) in fields"
                    :key="i"
                    :value="i"
                    @click="$emit('run', fieldItem.command)"
                >
                    <v-list-item-icon class="mr-2">
                        <v-icon dense small>{{ getIcon(fieldItem.icon) }}</v-icon>
                    </v-list-item-icon>
                    <v-list-item-content>
                        <v-list-item-title>{{ fieldItem.text }}</v-list-item-title>
                    </v-list-item-content>
                </v-list-item>
            </v-list-item-group>
        </v-list>
    </v-menu>
</template>

<script>
export default {
    name: 'AppWysiwygToolbarFieldMenu',
    props: {
        fields: {
            type: Object,
            required: true
        },
        active: {
            type: String,
            default: null
        },
        disabled: {
            type: Boolean,
            default: false
        }
    }
};
</script>
